import * as _4 from 'lodash4';
import { APModel } from '../../../../../global/models/ap_model';
import { IFeedbackTransaction } from '../../builders/plan_feedback_transaction_builder';
import { TemplateChangesGroupedByTransactionType } from '../../queries/advisor_compare_query';

class PlanFeedbackTemplateChangesCtrl {
  private pgmName: string;
  private groupedSuggestions: TemplateChangesGroupedByTransactionType;

  constructor(private ngAPModel: APModel) {}

  $onInit() {
    this.pgmName = _4.head(_4.toArray(this.ngAPModel.read().program)).name;
  }
}
angular.module('capability-ng-academic-planner').component('planFeedbackTemplateChanges', {
  controller: PlanFeedbackTemplateChangesCtrl,
  templateUrl:
    'capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_template_changes/plan_feedback_template_changes.html',
  bindings: {
    groupedSuggestions: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/components/plan_feedback_template_changes/plan_feedback_template_changes.ts